<template>
  <Drawer v-model="openMap" height="280" placement="bottom">
    <div id="share">
      <Form ref="item" :label-width="80">
        <Row :gutter="16">
          <Col span="24">
            <h3>位置分享：{{ item.carNo }}</h3>
          </Col>
          <Col span="24">
            截止时间：{{ utils.time(item.endTime) }}
            <div id="qucliy">
              <a
                @click="end(x)"
                v-for="(x, index) in shichang"
                :class="{ active: now == x }"
                :key="index"
                >{{ x }}小时</a
              >
            </div>
          </Col>
          <Col span="12">
            <Button long type="primary" @click="share">立即分享</Button>
          </Col>
          <Col span="12">
            <Button long @click="endshare">结束分享</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <shareMakeCode ref="shareMakeCode"></shareMakeCode>
  </Drawer>
</template>
<script>
import axios from "axios";
import shareMakeCode from "./shareMakeCode.vue";
export default {
  components: { shareMakeCode },
  data() {
    return {
      openMap: false,
      item: {
        deviceNo: "",
        carNo: "",
        href: "",
        endTime: new Date(),
      },
      shichang: [2, 4, 8, 24, 48, 72],
      ruleValidate: {
        endTime: { required: true, message: "必填" },
      },
      now: 2,
    };
  },
  methods: {
    open(v) {
      this.item.carNo = v.carNo;
      this.item.deviceNo = v.deviceNo;
      this.openMap = true;
    },

    end(t) {
      this.now = t;
      var now = Date.now();
      var to = t * 3600000;
      this.item.endTime = new Date(now + to);
    },
    share() {
      this.utils.loading(this, "生成中");
      let params = {
        deviceNo: this.item.deviceNo,
        expiredTime: this.item.endTime.getTime(),
      };
      axios({
        method: "post",
        url: axios.lbs + "/share/start",
        data: params,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        if (res) {
          if (res) {
            var data = res.data.data;
            console.log(res);
            this.item.href = data;
            if (data != null) {
              this.openMap = false;
              this.$refs.shareMakeCode.makeCode(this.item);
            }
          }
        }
      });
    },
    endshare() {
      let params = {
        deviceNo: this.item.deviceNo,
      };
      axios({
        method: "post",
        url: axios.lbs + "/share/end",
        data: params,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        if (res) {
          if (res) {
            this.reset();
          }
        }
      });
    },
    reset() {
      this.openMap = false;
      this.item.href = "";
    },
  },
  mounted() {
    this.end(this.now);
  },
};
</script>
<style lang="">
#share {
  width: 100%;
  height: 200px;
}
#share h3 {
  font-size: 18px;
}
#qucliy {
  margin-bottom: 34px;
  margin-top: 20px;
}
#qucliy a {
  display: inline-block;
  background: #fff;
  margin:0px 2px;
  margin-bottom: 20px;
  width: calc(33% - 4px);
  text-align: center;
  line-height: 24px;
}
#qucliy a.active {
  background: #c6e4f9;
}
#qucliy a:nth-child(3n) {
  margin-right: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/locate/com/share.vue